import {
  BrokerId,
  FrontendBroker,
  FrontendLoadLocation,
} from '@trucksmarter/shared';
import { DallasTableDataCell } from '@ui/Dallas/Table/DallasTable';
import { AppointmentCellContent } from './AppointmentCell';
import DallasStack from '@ui/Dallas/Stack/DallasStack';
import BrokerDisplayLogo from '../../../../_ui/BrokerDisplay/BrokerDisplayLogo';
import FactorableBadge from '../../../../_ui/FactorableBadge/FactorableBadge';

import styles from './BrokerCell.module.scss';

interface Props {
  className?: string;
  broker?: FrontendBroker;
  location: FrontendLoadLocation;
}

export default function BrokerAndPickupCell({
  className,
  broker,
  location,
}: Props) {
  return (
    <DallasTableDataCell className={className}>
      <DallasStack gap="xs">
        <DallasStack gap="2xs" direction="row" alignHorizontal="start">
          {broker?.isFactorable === true && <FactorableBadge />}
          <BrokerDisplayLogo
            className={styles.brokerLogo}
            broker={broker}
            textNoWrap
          />
        </DallasStack>
        {!!broker?.broker && (
          <DallasStack direction="row" gap="2xs">
            <AppointmentCellContent
              location={location}
              brokerId={broker.broker as BrokerId}
            />
          </DallasStack>
        )}
      </DallasStack>
    </DallasTableDataCell>
  );
}
